import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: {},
    error: "",
    dataArray: [],
    lowestPrice: {},
  },
  action
) {
  switch (action.type) {
    case homeConstants.COUPON_PRICE_REQUEST:
      return {
        ...state,
        data: {},
        dataArray: [],
        isProgress: true,
        lowestPrice: {},
      };
    case homeConstants.COUPON_PRICE_UPDATE:
      return {
        ...state,
        data: action.data,
      };
    case homeConstants.COUPON_PRICE_LOWEST_UPDATE:
      return {
        ...state,
        lowestPrice: action.data,
      };
    case homeConstants.COUPON_PRICE_RESET:
      return {
        isProgress: false,
        data: {},
        error: "",
        dataArray: [],
        lowestPrice: {},
      };
    case homeConstants.COUPON_PRICE_SUCCESS:
      return {
        data: {},
        isProgress: false,
        dataArray: action.response.data.priceList || [],
        lowestPrice: action.response.data.lowestPrice,
      };
    case homeConstants.COUPON_PRICE_FAILURE:
      return {
        data: {},
        dataArray: [],
        lowestPrice: {},
        error: action.error,
        isProgress: false,
      };
    case homeConstants.RESET_DATA:
      return {
        ...state,
        data: {},
        dataArray: [],
        lowestPrice: {},
      };
    default:
      return state;
  }
}
